export default __webpack_public_path__ + "static/media/request-complete.0fb03533.svg";